'use client';
import Image from 'next/image';
import { LocationSelector } from '../LocationSelector';
import { useCityId, useCountryId, useRegionId, useSetLocation } from '@/contexts/CookieContext';
import { IconChevronRight } from '@tabler/icons-react';
import clsx from 'clsx';
import { Button } from '@/components/ui/button';

type GeoSelectorProps = {
  onSelectGeo?: (location: any) => void;
  rightSideText?: boolean;
};

export const GeoSelector = ({ onSelectGeo, rightSideText = false }: GeoSelectorProps) => {
  const regionId = useRegionId();
  const cityId = useCityId();
  const countryId = useCountryId();
  const updateLocation = useSetLocation();

  return (
    <LocationSelector
      defaultState={{ regionId, cityId, countryId }}
      onChange={(location) => {
        updateLocation(
          location.countryId ?? '',
          location.regionId ?? '',
          location.cityId ?? '',
          { lat: location.latitude ?? 0, lon: location.longitude ?? 0 },
          () => {
            onSelectGeo?.(location);
          },
        );
      }}
      rightSideText={rightSideText}
      GeoShowElement={ShowElem}
    />
  );
};

export const ShowElem = ({
  text,
  rightSideText: _rightSideText,
  ...props
}: {
  text: string;
  rightSideText?: boolean;
}) => {
  return (
    <Button
      type='button'
      {...props}
      variant='ghost'
      className={clsx('h-auto p-0 gap-[4px] items-center text-secondary hover:bg-transparent min-w-0')}
    >
      <Image
        width={20}
        height={20}
        alt='geo'
        src='/assets/icons/geo-point.svg'
        className='h-[20px] w-[20px] mt-[-2px]'
      />
      <span className='lg:text-[16px] text-[13px] text-secondary truncate max-w-full flex-1 text-start'>{text}</span>
    </Button>
  );
};

export const FormShowElem = ({
  text,
  rightSideText: _rightSideText,
  ...props
}: {
  text: string;
  rightSideText?: boolean;
}) => {
  return (
    <Button
      type='button'
      {...props}
      variant='ghost'
      className='h-[46px] w-full justify-between gap-[12px] px-0 hover:bg-transparent'
    >
      <div className='flex items-center gap-[12px]'>
        <div className='flex items-center shrink-0 justify-center size-[46px] rounded-full bg-[#F7F7F7]'>
          <Image src='/assets/icons/map-pin.svg' width={24} height={24} alt='Location' />
        </div>
        <p className='text-primary line-clamp-2 break-after-right text-[16px] font-medium'>{text}</p>
      </div>
      <div className='size-[24px] flex items-center justify-center'>
        <IconChevronRight color='#999999' />
      </div>
    </Button>
  );
};
